<template>
  <button
    class="ml-2 bg-transparent p-1 text-sm"
    :class="{
      hidden: !isFilterActive,
    }"
    @click.stop="clearFilter()"
  >
    <BaseIcon class="max-w-fit invert" :icon="Icon.REMOVE_FILTER" />
  </button>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { Icon } from "../../../../assets/icons/Icon";
import BaseIcon from "../../../../components/BaseIcon.vue";
import { FilterValueType } from "../../type.genericTableQuery";
defineProps<{ format: string }>();
const filterValueType = defineModel<FilterValueType>("filters", { required: true });
const filter = computed(() => filterValueType.value.filter);

const isFilterActive = computed(() => {
  if (!filter.value) {
    throw new Error();
  }
  return filter.value.value !== undefined;
});

function clearFilter() {
  if (!filter.value) {
    throw new Error();
  }
  filter.value.value = undefined;
}
</script>
